
import { useRef, useMemo, useState, useContext, useEffect } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const useServerDatabase = () => {
    const tagRef = useRef(null);
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [enabelPopup, setEnabelpopup] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [dbInputs, setDbInputs] = useState([{ database_name: "", users: [] }]);
    const [editData, setEditData] = useState({});
    const [option, setOptions] = useState({ project: [], server: [], users: [] });
    const [filterValues, setFilterValues] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);
    const [columns] = useState([
        { field: "project_name", header: "Project Name", width: "15%" },
        { field: "server_name", header: "Server Name", width: "15%" },
        { field: "database_name", header: "Database Names", width: "15%" },
        { field: "approver_user_codes", header: "Approver User Name", width: "20%" },
        { field: "Actions", header: "Actions", width: "10%" },
    ]);

    useEffect(() => {
        callautopopulate("projects", "server_details", "all_users").then(res => {
            setOptions((prev) => ({ ...prev, project: res?.projects?.sort((a, b) => a.project_name?.localeCompare(b.project_name)), server: res?.server_details?.sort((a, b) => a.server_name?.localeCompare(b.server_name)), users: _.sortBy(res?.all_users, "user_display_name") }))
        });
    }, []);

    useEffect(() => {
        const serverName = filterValues?.server?.server_name;
        if (!serverName || !option?.server?.length) return;
        const selectedServer = _.find(option.server, s => s.server_name === serverName)
        if (!selectedServer) return;
        setFilterValues(prev => ({
            ...prev,
            server_local_ip: selectedServer.server_local_ip || "",
            server_static_ip: selectedServer.server_static_ip || "",
        }));
    }, [filterValues?.server?.server_name, option?.server]);

    useEffect(() => {
        filterValues?.apiCall && getServerData()
    }, [filterValues?.apiCall])

    const getServerData = async () => {
        try {
            setLoader(true);
            const payload = {
                project_ids: _.pluck(filterValues?.projects, "project_id").toString(),
            };
            const res = await services.getInvokeRemote("POST", Urls("GETSERVERDATABASEDATABASEDATA"), payload);
            if (res?.body?.data?.server_database_data) {
                const rawData = res?.body?.data?.server_database_data || [];
                const data = rawData.map(item => ({ ...item, project_server_key: `${item.project_id}-${item.server_name}` }));
                data.sort((a, b) => a.project_name.localeCompare(b.project_name) || a.server_name.localeCompare(b.server_name) || a.database_name.localeCompare(b.database_name));
                setRowData(data)
                setFilterValues((prev) => ({ ...prev, apiCall: false }))
            }
        } catch (err) {
            console.error(err);
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
            setRowData([]);
        } finally {
            setLoader(false);
        }
    };

    const handleUpsertServerdata = async () => {
        try {
            if (!filterValues?.project) {
                showInfo("Info", "Please select project");
                return;
            }

            if (!filterValues?.server?.server_name) {
                showInfo("Info", "Please select Server Name");
                return;
            }

            if (!filterValues.server_local_ip?.trim()) {
                showInfo("Info", "Please enter Server Local IP");
                return;
            }

            if (!filterValues.server_static_ip?.trim()) {
                showInfo("Info", "Please enter Server Static IP");
                return;
            }

            if (!filterValues.location_name?.trim()) {
                showInfo("Info", "Please enter Location Name");
                return;
            }
            const filledRows = _.filter(dbInputs, d => d.database_name && d.database_name.trim() !== "");
            if (_.isEmpty(filledRows)) {
                return showInfo("Info", "Please enter at least one Database Name");
            }

            if (_.some(filledRows, r => _.isEmpty(r.users))) {
                return showInfo("Info", "Please select users");
            }
            const tvpArray = _.map(filledRows, row => ({
                database_name: row.database_name.trim(),
                approver_user_code: _.map(row.users, 'user_code').join(",")
            }));
            setLoader(true);
            const payload = {
                project_id: filterValues?.project || 0,
                server_id: filterValues?.server?.server_id || 0,
                server_name: filterValues?.server?.server_name,
                server_local_ip: filterValues.server_local_ip || "",
                server_static_ip: filterValues.server_static_ip || "",
                location_name: filterValues.location_name || "",
                server_request_approver: tvpArray
            };
            const res = await services.getInvokeRemote("POST", Urls("UPSERTSERVERDATABASEDATA"), payload);
            if (res?.body?.data) {
                showSuccess('Success', res.body.message)
                getServerData();
                sessionStorage.removeItem("server_details");
                const serverdetails = await callautopopulate("server_details");
                const server = serverdetails?.server_details || [];
                setOptions(prev => ({
                    ...prev,
                    server: _.sortBy(server, "server_name"),
                }));
                setIsEditMode(false)
                setEnabelpopup(false);
                setEditData({});
                setDbInputs([{ database_name: "", users: [] }]);
                setFilterValues({ projects: [], server: null, server_local_ip: "", server_static_ip: "", location_name: "", database_names: "", users: [], });
            }
            else {
                showError("Error", res?.body?.message);
            }
        } catch (error) {
            console.error(error);
            showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setLoader(false);
        }
    };
    const handleEdit = (data) => {
        setIsEditMode(true);
        setEditData(data);
        setEnabelpopup(true);
        const filteredRows = _.filter(rowData, r =>r.project_id === data.project_id && r.server_id === data.server_id);
        const dbArray = _.map(filteredRows, (r) => {

            const approverCodes = _.filter(
                (r.approver_user_codes || "").split(","),
                (code) => code.trim() !== ""
            );


            const matchedUsers = _.filter(option.users || [], (u) =>
                approverCodes.includes(String(u.user_code))
            );

            return {
                database_name: (r.database_name || "").trim(),
                users: matchedUsers
            };
        });
      
        setDbInputs(dbArray.length ? dbArray : [{ database_name: "", users: [] }]);

        setFilterValues(prev => ({
            ...prev,
            project: data.project_id || null, 
            server: data.server_name
                ? { server_id: data.server_id, server_name: data.server_name }
                : null,
            server_local_ip: data.server_local_ip || "",
            server_static_ip: data.server_static_ip || "",
            location_name: data.location_name || "",
        }));
    };

    
    const handleDelete = async (data) => {
        try {
            const payload = {
                server_id: data.server_id
            };
            const res = await services.getInvokeRemote("POST", Urls("REMOVESERVERDATABASEDATA"), payload);
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                sessionStorage.removeItem("server_details");
                const serverdetails = await callautopopulate("server_details");
                setOptions((prev) => ({ ...prev, server: _.sortBy(serverdetails?.server_details || [], "server_name") }));
                setFilterValues((prev) => ({ ...prev, server: null }));
                getServerData()
            } else {
                showError("Error", res?.body?.errorMessage);
            }
        } catch (error) {
            console.error(error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    };

    const resetForm = () => {
        setIsEditMode(false)
        setEnabelpopup(false);
        setEditData({});
        setDbInputs([{ database_name: "", users: [] }]);
        setFilterValues({ projects: [], server: null, server_local_ip: "", server_static_ip: "", location_name: "", database_names: "", users: [], });
    };


    return useMemo(
        () => ({ tagRef, enabelPopup, setEnabelpopup, option, filterValues, setFilterValues, rowData, loader, getServerData, handleUpsertServerdata, resetForm, showInfo, dbInputs, setDbInputs, handleDelete, isEditMode, columns, handleEdit }),
        [tagRef, enabelPopup, setEnabelpopup, option, filterValues, setFilterValues, rowData, loader, getServerData, handleUpsertServerdata, resetForm, showInfo, dbInputs, setDbInputs, handleDelete, isEditMode, columns, handleEdit]
    );
};

